export { PaginationComponent } from './pagination.component';
export { L_PaginationModule } from './pagination.module';



// WEBPACK FOOTER //
// ./.tmp/pagination/index.ts